module.exports = __webpack_public_path__ + "static/media/pic8.2ce94c8c.jpg";